var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackTop),expression:"showBackTop"}],staticClass:"back-to-top",class:{ 'show': _vm.showBackTop },on:{"click":_vm.scrollToTop}},[_c('span',{staticClass:"arrow"}),_vm._v("\n  返回顶部\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }